<template>
  <div>
    <van-nav-bar fixed title="公告详情" left-arrow @click-left="goBack"/>
    <div class="v_mainBox">
      <div class="van-title">{{ title }}</div>
      <p class="van-data">
        <i class="van-icon van-icon-clock"></i>
        <span>{{ createTime }}</span>
      </p>
      <p class="van-infor-txt">{{ content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      flags: false,
      title: '',
      createTime: '',
      content: '',
    }
  },
  created() {
    this.title = this.$route.query.title
    this.createTime = this.$route.query.createTime
    this.content = this.$route.query.content
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.v_mainBox {
  width: 90%;
  height: auto;
  display: block;
  overflow: hidden;
  margin: auto;
  padding-top: 50px;
}

.v_mainBox p {
  padding: 0;
  margin: 0;
}

.van-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  overflow: hidden;
  font-weight: bold;
  display: block;
}

.van-icon {
  color: #3778d0 !important;
  padding-right: 6px;
  float: left;
  display: block;
  margin-top: 7px;
}

.van-data {
  width: 100%;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  overflow: hidden;
  color: #999;
  display: block;
}

.van-infor-txt {
  width: 100%;
  height: auto;
  font-size: 13px;
  color: #515151;
  margin-top: 10px !important;
  text-indent: 2em;
  line-height: 25px;
}
</style>
